import { render } from "./InsideSlider.vue?vue&type=template&id=5fd70770&scoped=true"
import script from "./InsideSlider.vue?vue&type=script&lang=js"
export * from "./InsideSlider.vue?vue&type=script&lang=js"

import "./InsideSlider.vue?vue&type=style&index=0&id=5fd70770&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd70770"]])

export default __exports__